import { createI18n } from 'vue-i18n'
import zh from './locales/zh'
import en from './locales/en'
// 语言切换暂时停用，默认固定中文；后续启用时可恢复 localStorage 读取
// const lang = localStorage.getItem('lang') || 'zh'
const lang = 'zh'
const i18n = createI18n({
    locale: lang, // 默认语言
    fallbackLocale: 'en',
    messages: {
        zh,
        en
    }
})

export default i18n
